/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Meta_Ogtitle1Inputs */

const ja_calendar_meta_ogtitle1 = /** @type {(inputs: Calendar_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン - 運営イベント`)
};

const en_calendar_meta_ogtitle1 = /** @type {(inputs: Calendar_Meta_Ogtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Watch Now`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Watch Now" |
*
* @param {Calendar_Meta_Ogtitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const calendar_meta_ogtitle1 = /** @type {((inputs?: Calendar_Meta_Ogtitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Meta_Ogtitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_calendar_meta_ogtitle1(inputs)
	return en_calendar_meta_ogtitle1(inputs)
});
export { calendar_meta_ogtitle1 as "calendar_meta_ogTitle" }